module.exports = __webpack_public_path__ + "static/media/o.c9849407.png";